import type { PolicyHolder, WebShopPublicUser } from "@/api_client";

import type {
  CustomerInfo,
  CustomerType,
  CustomerTypeValue,
  ObjectId,
} from "../types/types";

const getCustomerStatus = (
  policyHolder: PolicyHolder | undefined | null,
): CustomerTypeValue[] => {
  const statusValue: CustomerType =
    policyHolder?.informationSource === "Scalu" ? "Existing" : "New";
  return [
    {
      type: "if",
      value: statusValue,
    },
  ];
};

const getCustomerId = (
  policyHolder: PolicyHolder | undefined | null,
): ObjectId => {
  return {
    id: policyHolder?.ssn,
    type: "SSN",
  };
};

const userIsLoggedIn = (user: WebShopPublicUser | undefined): boolean => {
  return user?.isAuthenticated || false;
};

const getCustomerInfo = (
  enigmatizedPolicyHolder: PolicyHolder | undefined | null,
  user: WebShopPublicUser | undefined,
  moving: boolean | undefined,
): CustomerInfo => {
  return {
    loggedIn: userIsLoggedIn(user),
    customerId: getCustomerId(enigmatizedPolicyHolder),
    age: enigmatizedPolicyHolder?.age,
    gender: enigmatizedPolicyHolder?.gender,
    email: enigmatizedPolicyHolder?.email,
    phone: enigmatizedPolicyHolder?.mobilePhoneNumber,
    firstName: enigmatizedPolicyHolder?.firstName,
    lastName: enigmatizedPolicyHolder?.lastName,
    customerStatus: getCustomerStatus(enigmatizedPolicyHolder),
    isObjectPossessor: undefined,
    moving,
    retired: undefined,
  };
};

export default {
  getCustomerInfo,
};
